import React /*, { useState }*/ from "react";
import { useDispatch } from "react-redux";
import styles from "./promotionCardList.scss";
import "./promotionCardList.css";
import PromotionCard from "../../../common/components/promotionCard/promotionCard";
import { updateItemQuantity } from "../../../common/redux/reducers";
import EmptyListTemplate from "../../../../common/components/emptyListTemplate/emptyListTemplate";
import { removeToWishlist, addToWishlist } from "../../../../common/utils/apis";
import { toggleCollection } from "../../../common/redux/reducers/index";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";

function PromotionCardList({ listDetails, col }) {
  const dispatch = useDispatch();
  const gridArray = [];
  listDetails &&
    listDetails.length > 0 &&
    listDetails.filter(Boolean).map((element, index) => {
      let condition = index % col;
      if (gridArray[condition]) {
        gridArray[condition].push(element);
      } else {
        gridArray[condition] = [element];
      }
    });

  const setQuantity = (itemCode) => (quantity) => {
    try {
      dispatch(updateItemQuantity(itemCode, quantity));
    } catch (error) {
      toastMsg(error?.response?.data?.message);
      console.log(error);
    }
  };

  const toggleWishList = async (product) => {
    try {
      if (product.isCollected) {
        const res = await removeToWishlist(product.productCode);

        toastMsg(res?.data?.message);
      } else {
        const res = await addToWishlist(product.productCode);
        toastMsg(res?.data?.message);
      }
      dispatch(toggleCollection(product?.itemCode, "promotionPlp"));
    } catch (error) {
      console.error(error);
      toastMsg(error?.response?.data?.message);
    }
  };

  return (
    <div className={styles["container"]}>
      {gridArray && gridArray.length ? (
        <div className={styles["plp-grid"]}>
          {gridArray.map((arr, index) => (
            <div className={styles["plp-odd-grid"]} key={index}>
              {arr.map(
                (product, i) =>
                  product && (
                    <div key={`product_${i}`} className={styles["card-margin"]}>
                      <PromotionCard
                        key={i}
                        product={product}
                        isWishlisted={product.isCollected}
                        CheckedPlp={
                          product.quantity && product.quantity > 0
                            ? CheckedPlp
                            : null
                        }
                        cartText="加入購物車"
                        quantity={product.quantity || 0}
                        onQuantityChange={setQuantity(product.itemCode)}
                        displayAddToCart={false}
                        toggleWishList={toggleWishList}
                      />
                    </div>
                  )
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className={styles["empty-list"]}>
          <EmptyListTemplate message="沒有促銷商品" />
        </div>
      )}
    </div>
  );
}

const CheckedPlp = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles["checked-plp-svg"]}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16343 24.8366 0 16 0C7.16343 0 0 7.16343 0 16C0 24.8366 7.16343 32 16 32ZM16 28.9032C8.8689 28.9032 3.09679 23.1322 3.09679 16C3.09679 8.8689 8.86783 3.09679 16 3.09679C23.1311 3.09679 28.9032 8.86783 28.9032 16C28.9032 23.1311 23.1322 28.9032 16 28.9032ZM25.0411 12.596L13.9063 23.6414C13.6028 23.9426 13.1126 23.9406 12.8115 23.637L6.95465 17.7328C6.65349 17.4292 6.65551 16.9389 6.95906 16.6379L8.42479 15.1839C8.72834 14.8828 9.21851 14.8848 9.51961 15.1884L13.3772 19.0772L22.4967 10.0311C22.8002 9.7299 23.2904 9.73185 23.5915 10.0354L25.0454 11.5011C25.3465 11.8046 25.3446 12.2949 25.0411 12.596Z"
        fill="#107F47"
      />
    </svg>
  );
};

export default PromotionCardList;
